import { Suspense } from 'react';

import { useParams } from 'react-router';

import { BenefitItem } from './components/BenefitItem/BenefitItem';
import { EmailDetails } from './components/EmailDetails/EmailDetails';
import {
  useGetBuyerSpendingLimit,
  useGetSellerByHandle,
  useGetStateByStateKeyIfLoggedIn,
} from '../../api/lending/lapiHooks';
import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen';
import IwocaPayIcon from '../../components/svg/IwocaPayIcon.svg?react';
import { useSellerWhitelabelling } from '../../hooks/useSellerWhiteLabelling.hook';
import { GenericError } from '../../Pages/FailurePages/GenericError';
import { useThreatMetrix } from '../../utils/ThreatMetrix';
import { HelpBox } from '../components/HelpBox/HelpBox';
import { WhiteLabelPayLinkLogo } from '../components/WhiteLabelLogo/WhiteLabelLogo';
import { useTrackLandingPageView } from '../hooks/useTrackLandingPageView';
import { redirectToMyAccount } from '../Signup/useRedirectToAccountPages';

export const SpendingLimitRequestLanding = () => {
  const { sellerHandle } = useParams();
  const { sellerError, seller, loadingSeller } =
    useGetSellerByHandle(sellerHandle);

  const { state: customerState, loadingState } =
    useGetStateByStateKeyIfLoggedIn();
  const { spendingLimit } = useGetBuyerSpendingLimit();

  const isSignedIn = Boolean(customerState);

  // White-label theme.
  const { theme, showSellerLogo } = useSellerWhitelabelling(sellerHandle);

  useTrackLandingPageView({
    payLinkType: 'spending_limit',
    visibleOptions: ['THREE_MONTHS'],
    productPricing: seller?.product_pricing!,
    sellerId: seller?.seller_id,
    loadingApis: loadingSeller || loadingState,
  });

  useThreatMetrix();

  if (spendingLimit?.data?.active_spending_limit) {
    redirectToMyAccount();
  }

  if (sellerError) {
    return <GenericError errorText={sellerError} />;
  }
  if (!seller || loadingState) {
    return <LoadingScreen />;
  }

  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="min-h-screen bg-secondary-95 text-left">
        <div className="mx-auto max-w-[600px] pt-2xl">
          <div className="rounded-l border border-secondary-90 bg-white p-xl max-600:rounded-none max-600:p-l">
            {showSellerLogo && (
              <WhiteLabelPayLinkLogo
                // showSellerLogo = true --> logo_uri & preferred_logo_type present.
                url={theme!.logo_uri!}
                ratio={theme!.preferred_logo_type!}
                themeColor={theme!.primary_color}
                className="mt-0"
              />
            )}
            {!showSellerLogo && (
              <IwocaPayIcon className="mb-l w-[110px] fill-coral-65" />
            )}
            <div className="text-2xl font-bold">
              {isSignedIn
                ? 'Apply for a spending limit today'
                : 'Create your account today'}
            </div>
            <ul className="my-l flex flex-col gap-s p-0">
              {!isSignedIn && <BenefitItem>Sign up in 3 minutes</BenefitItem>}
              <BenefitItem>Access up to £30k to spend</BenefitItem>
              <BenefitItem>Get more time to pay</BenefitItem>
            </ul>
            <EmailDetails />
          </div>
          <HelpBox />
        </div>
      </div>
    </Suspense>
  );
};
